module.exports = __webpack_public_path__ + "static/media/10.ad4310ce.jpg";